export const templateImgStyle = screenWidth => ({
  maxHeight: screenWidth ? (screenWidth * 45) / 100 + 'px' : '140px',
})

export const messageWidth = (screenWidth) => {
  return {width: screenWidth ? screenWidth - 112 + 'px' : '254px'}
}

export const messageLogoWidth = (screenWidth) => {
  return ({
    width: screenWidth ? screenWidth - 112 + 'px' : '254px'
  })
}

export const carouselContainerWidth = (screenWidth) => {
  return {width: screenWidth ? screenWidth - 112 + 'px' : '254px'}
}

export const getImageHeight = (device) => {
  return device.width ? (device.width * 45 / 100) + 'px' : '140px'
}
